// removed by extract-text-webpack-plugin
module.exports = {"BuildControl":"BuildControl__BuildControl__2CYUG","Label":"BuildControl__Label__1UdCT","Less":"BuildControl__Less__2d3iY","More":"BuildControl__More__24RLv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Poke/BuildControls/BuildControl/BuildControl.css
// module id = 151
// module chunks = 0